var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#999999;}\n\t.st2{clip-path:url(#SVGID_00000164485066935277776810000002183966584826880177_);}\n\t.st3{clip-path:url(#SVGID_00000082336903278411156900000003057880640374433969_);}\n\t.st4{fill:none;stroke:#999999;stroke-width:2.2321;}\n\t.st5{clip-path:url(#SVGID_00000113322575404477467520000017335666703480082357_);}\n\t.st6{fill:#FF6CE2;}\n\t.st7{fill:#7B3566;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.26,15.1v19.8h35.47V15.1H7.26z M40.6,32.77H9.4V17.23h31.2V32.77z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons23);
export default __webpack_public_path__ + "static/media/Icons-23.2540843b42882a6fe2d93c4d895ab1df.svg";
export { ForwardRef as ReactComponent };